export const ERROR = "ERROR";
export const SUCCESS = "SUCCESS";
